import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { BRING_FLOATING_SIDE_PANEL_TO_FRONT, CLOSE_ALL_SIDE_PANELS, DOCK_SIDE_PANEL_TAB, OPEN_SIDE_PANEL_TAB, POP_OUT_SIDE_PANEL_TAB, REMOVE_SIDE_PANEL_TAB, SET_ACTIVE_SIDE_PANEL_TAB, SET_FLOATING_SIDE_PANEL_GEOMETRY, SET_SIDE_PANEL_IS_RESIZING, SET_SIDE_PANEL_WIDTH, SET_USER_SIDE_PANEL_WIDTH } from './actionTypes';
import { DEFAULT_SIDE_PANEL_WIDTH, FLOATING_Z_INDEX_BASE, SIDE_PANEL_FEATURE_KEY } from './constants';
const DEFAULT_STATE = {
    activeTab: null,
    floatingGeometry: {},
    floatingTabs: [],
    isResizing: false,
    nextFloatingZIndex: FLOATING_Z_INDEX_BASE,
    openTabs: [],
    width: {
        current: DEFAULT_SIDE_PANEL_WIDTH,
        userSet: null
    }
};
// 必须传入 DEFAULT_STATE：否则重水合只恢复 { width }，openTabs 等为 undefined，SidePanelHost 读 .length 会黑屏崩溃。
PersistenceRegistry.register(SIDE_PANEL_FEATURE_KEY, {
    width: true
}, DEFAULT_STATE);
/**
 * Registers the side panel reducer.
 */
ReducerRegistry.register(SIDE_PANEL_FEATURE_KEY, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case OPEN_SIDE_PANEL_TAB: {
            const tabId = action.tabId;
            const openTabs = state.openTabs.includes(tabId)
                ? state.openTabs
                : [...state.openTabs, tabId];
            return {
                ...state,
                activeTab: tabId,
                openTabs
            };
        }
        case REMOVE_SIDE_PANEL_TAB: {
            const tabId = action.tabId;
            const openTabs = state.openTabs.filter(id => id !== tabId);
            const floatingTabs = state.floatingTabs.filter(id => id !== tabId);
            const { [tabId]: _removed, ...floatingGeometry } = state.floatingGeometry;
            let activeTab = state.activeTab;
            if (activeTab === tabId) {
                activeTab = openTabs.length ? openTabs[openTabs.length - 1] : null;
            }
            return {
                ...state,
                activeTab,
                floatingGeometry,
                floatingTabs,
                openTabs
            };
        }
        case SET_ACTIVE_SIDE_PANEL_TAB: {
            const tabId = action.tabId;
            if (!state.openTabs.includes(tabId)) {
                return state;
            }
            return {
                ...state,
                activeTab: tabId
            };
        }
        case CLOSE_ALL_SIDE_PANELS:
            return {
                ...state,
                activeTab: null,
                floatingGeometry: {},
                floatingTabs: [],
                openTabs: []
            };
        case POP_OUT_SIDE_PANEL_TAB: {
            const tabId = action.tabId;
            const openTabs = state.openTabs.filter(id => id !== tabId);
            const floatingTabs = state.floatingTabs.includes(tabId)
                ? state.floatingTabs
                : [...state.floatingTabs, tabId];
            let activeTab = state.activeTab;
            if (activeTab === tabId) {
                activeTab = openTabs.length ? openTabs[openTabs.length - 1] : null;
            }
            return {
                ...state,
                activeTab,
                floatingGeometry: {
                    ...state.floatingGeometry,
                    [tabId]: action.geometry
                },
                floatingTabs,
                nextFloatingZIndex: action.geometry.zIndex + 1,
                openTabs
            };
        }
        case DOCK_SIDE_PANEL_TAB: {
            const tabId = action.tabId;
            const floatingTabs = state.floatingTabs.filter(id => id !== tabId);
            const { [tabId]: _removed, ...floatingGeometry } = state.floatingGeometry;
            const openTabs = state.openTabs.includes(tabId)
                ? state.openTabs
                : [...state.openTabs, tabId];
            return {
                ...state,
                activeTab: tabId,
                floatingGeometry,
                floatingTabs,
                openTabs
            };
        }
        case SET_FLOATING_SIDE_PANEL_GEOMETRY: {
            const tabId = action.tabId;
            const current = state.floatingGeometry[tabId];
            if (!current) {
                return state;
            }
            return {
                ...state,
                floatingGeometry: {
                    ...state.floatingGeometry,
                    [tabId]: {
                        ...current,
                        ...action.geometry
                    }
                }
            };
        }
        case BRING_FLOATING_SIDE_PANEL_TO_FRONT: {
            const tabId = action.tabId;
            const current = state.floatingGeometry[tabId];
            if (!current || !state.floatingTabs.includes(tabId)) {
                return state;
            }
            const zIndex = state.nextFloatingZIndex;
            return {
                ...state,
                floatingGeometry: {
                    ...state.floatingGeometry,
                    [tabId]: {
                        ...current,
                        zIndex
                    }
                },
                nextFloatingZIndex: zIndex + 1
            };
        }
        case SET_SIDE_PANEL_WIDTH:
            return {
                ...state,
                width: {
                    ...state.width,
                    current: action.width
                }
            };
        case SET_USER_SIDE_PANEL_WIDTH:
            return {
                ...state,
                width: {
                    current: action.width,
                    userSet: action.width
                }
            };
        case SET_SIDE_PANEL_IS_RESIZING:
            return {
                ...state,
                isResizing: action.resizing
            };
        default:
            return state;
    }
});
